import { type QueriesOptions, type QueriesResults, useQueries as useQueriesOriginal } from "react-query";

import { useRegisterQueries } from "./use-register-queries";

// biome-ignore lint/suspicious/noExplicitAny: follow react-query's typing
export function useQueries<T extends Array<any>>(queries: readonly [...QueriesOptions<T>]): QueriesResults<T> {
	useRegisterQueries(queries.map((query) => query.queryKey).filter(Boolean));

	return useQueriesOriginal(queries);
}
